// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var Sentry = require("../../reason/Sentry.bs.js");
var PageTitle = require("../../reason/common/PageTitle.bs.js");
var PageViews = require("../../reason/PageViews.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var AuthSession = require("../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
var MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var TemporalPolyfill = require("temporal-polyfill");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var ReactErrorBoundary = require("react-error-boundary");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UpgradePlanWarning__Jsx3 = require("../../reason/common/UpgradePlanWarning__Jsx3.bs.js");
var ShowingsPageRelayQuery_graphql = require("../../__generated__/ShowingsPageRelayQuery_graphql.bs.js");
var ShowingsPageRelayShowingsByDay = require("./ShowingsPageRelayShowingsByDay.bs.js");
var ShowingsPageRelay_showing_graphql = require("../../__generated__/ShowingsPageRelay_showing_graphql.bs.js");

var convertFragment = ShowingsPageRelay_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShowingsPageRelay_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShowingsPageRelay_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, ShowingsPageRelay_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShowingsPageRelay_showing_graphql.node, convertFragment, fRef);
}

var ShowingFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ShowingsPageRelay$ShowingsComponent(props) {
  var showings = use(props.showings);
  var userHasPropertyDetailsFeature = UserSession.useHasPlanFeature("PROPERTY_DETAILS");
  var showingsByDay = Object.entries(Core__Array.reduce(showings, {}, (function (dict, showing) {
              var startDate = showing.startDateV2;
              if (startDate === undefined) {
                return dict;
              }
              var day = Caml_option.valFromOption(startDate).toPlainDate().toString();
              var arr = dict[day];
              var newArrForDay = arr !== undefined ? (arr.push(showing), arr) : [showing];
              dict[day] = newArrForDay;
              return dict;
            })));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                userHasPropertyDetailsFeature ? null : JsxRuntime.jsx(View__Jsx3.make, {
                        mb: "md",
                        children: Caml_option.some(JsxRuntime.jsx(UpgradePlanWarning__Jsx3.PropertyDetails.make, {}))
                      }),
                showingsByDay.map(function (param) {
                      var date = param[0];
                      var plainDayMonth = TemporalPolyfill.Temporal.PlainDate.from(date);
                      return JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(ShowingsPageRelayShowingsByDay.make, {
                                        date: plainDayMonth,
                                        showings: param[1].map(function (s) {
                                              return s.fragmentRefs;
                                            })
                                      }),
                                  className: "my-6"
                                }, date);
                    })
              ]
            });
}

var ShowingsComponent = {
  ShowingFragment: ShowingFragment,
  make: ShowingsPageRelay$ShowingsComponent
};

var convertVariables = ShowingsPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = ShowingsPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ShowingsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables, ShowingsPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ShowingsPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ShowingsPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ShowingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ShowingsPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ShowingsPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ShowingsPageRelay$Page(props) {
  var currentUserRole = AuthSession.useCurrentUserRole();
  var data = use$1(undefined, undefined, undefined, undefined);
  var tmp;
  tmp = currentUserRole === "AGENT" ? JsxRuntime.jsx(PageViews.RecordPageView.make, {
          page: PageViews.Page.makeShowingsPage()
        }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Upcoming showings"
                    }),
                tmp,
                JsxRuntime.jsx(MarkupHelpers.Container.make, {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(PageUITitle.make, {
                                    title: "Upcoming showings"
                                  }),
                              JsxRuntime.jsx(ShowingsPageRelay$ShowingsComponent, {
                                    showings: Core__Array.keepSome(data.upcomingShowingsV5.edges).map(function (edge) {
                                          return edge.node.fragmentRefs;
                                        })
                                  })
                            ],
                            className: "bg-white p-5 shadow rounded"
                          })
                    })
              ]
            });
}

var Page = {
  make: ShowingsPageRelay$Page
};

function ShowingsPageRelay$ErrorState(props) {
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
              children: JsxRuntime.jsx(ErrorComponent.make, {
                    message: "There was a problem loading your chapter's showings. Please refresh or try again later..."
                  })
            });
}

var ErrorState = {
  make: ShowingsPageRelay$ErrorState
};

function ShowingsPageRelay$LoadingState(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Loader.make, {}),
              className: "flex justify-center items-center grow h-full"
            });
}

var LoadingState = {
  make: ShowingsPageRelay$LoadingState
};

function ShowingsPageRelay$default(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: (function (_error) {
                  return JsxRuntime.jsx(ShowingsPageRelay$ErrorState, {});
                }),
              children: JsxRuntime.jsx(React.Suspense, {
                    children: Caml_option.some(JsxRuntime.jsx(LoggedInAgent.Provider.make, {
                              loaderComponent: Caml_option.some(JsxRuntime.jsx(ShowingsPageRelay$LoadingState, {})),
                              children: JsxRuntime.jsx(ShowingsPageRelay$Page, {})
                            })),
                    fallback: Caml_option.some(JsxRuntime.jsx(ShowingsPageRelay$LoadingState, {}))
                  }),
              onError: (function (error) {
                  Sentry.captureException(error, "ShowingsPageRelay.res", undefined, undefined, undefined);
                })
            });
}

var $$default = ShowingsPageRelay$default;

exports.ShowingsComponent = ShowingsComponent;
exports.Query = Query;
exports.Page = Page;
exports.ErrorState = ErrorState;
exports.LoadingState = LoadingState;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
